import React, { useEffect, useState } from "react";
import './styles/profile.css';
import { useDispatch } from "react-redux";
import { logout } from "../reducers/userReducer";
import defaultProfileImage from '../assets/img/profile.png';
import { useNavigate, Link } from "react-router-dom";
import config from "../config";
import Tab from './Tab';
import SettingsModal from './SettingsModal';
import { useTranslation } from "react-i18next";

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const Profile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [userData, setUserData] = useState(null);
    const [profileImage, setProfileImage] = useState(defaultProfileImage);
    const [loading, setLoading] = useState(true);
    const [showPassword, setShowPassword] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation();

    const openSettingsModal = () => setIsModalOpen(true);
    const closeSettingsModal = () => setIsModalOpen(false);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const response = await fetch(`${config.apiUrl}/api/auth/profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setUserData(data.user);

                    if (data.user.profilePhoto) {
                        const imageUrl = new URL(data.user.profilePhoto, config.apiUrl).toString();
                        setProfileImage(imageUrl);
                    } else {
                        setProfileImage(defaultProfileImage);
                    }
                    setLoading(false);
                } else {
                    console.error('Failed to fetch user profile:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching user profile:', error.message);
            }
        };

        fetchUserProfile();
    }, []);

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('profileImage', file);
            formData.append('phone', userData.phone);

            try {
                const response = await fetch(`${config.apiUrl}/api/upload/profile-image`, {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    const data = await response.json();
                    setProfileImage(`${config.apiUrl}${data.imageUrl}`);
                } else {
                    console.error('Failed to upload image:', response.statusText);
                }
            } catch (error) {
                console.error('Error uploading image:', error.message);
            }
        }
    };

    return (
        <div className="profile">
            <header className='header-main'>
                <h1 className='text-header'>Профиль</h1>
            </header>

            <div className="section__profile">
                <SettingsModal isOpen={isModalOpen} onClose={closeSettingsModal} />

                <div className="profile__img-wrapper">
                    <img src={profileImage} alt="Profile" className="profile__img" />
                </div>

                <label className="uploadProfile-img">
                    Загрузить фото профиля
                    <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />
                </label>

                {loading ? (
                    <p>Загрузка...</p>
                ) : (
                    userData && (
                        <div className="info-card">
                            <p className="name info-el">{userData.name} {userData.surname}</p>
                            <p className="info-el">Телефон: {userData.phone}</p>
                            <p className="info-el">Филиал: {userData.selectedFilial}</p>
                            <p className="info-el">Создан: {formatDate(userData.createdAt)}</p>

                            <div className="password-field-profile">
                                <span className="password-label">Пароль:</span>
                                <div className="password-display">
                                    <span className="password-value">
                                        {showPassword ? userData.password : '•'.repeat(Math.min(userData.password?.length || 0, 12))}
                                    </span>
                                    <button 
                                        className="password-toggle-btn-profile"
                                        onClick={() => setShowPassword(!showPassword)}
                                        title={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                                    >
                                        {showPassword ? '👁️' : '🔒'}
                                    </button>
                                </div>
                            </div>

                            <button className="settings-button" onClick={openSettingsModal}>
                                Настройки
                            </button>
                        </div>
                    )
                )}

                {userData && (userData.role === 'admin' || userData.role === 'filial') && (
                    <Link to="/dashboard" className="verify">{t('menu.dashboard')}</Link>
                )}

                {userData && userData.role === 'super_admin' && (
                    <Link to="/dashboard" className="verify">Панель управления</Link>
                )}

                {userData && userData.role === 'company_admin' && (
                    <Link to="/dashboard" className="verify">Панель управления</Link>
                )}

                <div className="logout" onClick={() => {
                    dispatch(logout());
                    navigate("/");
                }}>
                    {t('menu.logout')}
                </div>
            </div>

            <div className="area3"></div>
            <Tab />
        </div>
    );
};

export default Profile;
